<template>
    <div
    v-for="(block, index) in paymentData"
    :key="index"
    class="step-section">
        <!-- Divider -->
        <divider-generic
        v-if="!block.divider.hidden"
        :dividerSize="'medium'"
        :icon="block.divider.icon"
        :title="block.divider.title"
        :applyBorder="block.divider.applyBorder"/>
        <!-- Text Block -->
        <text-blocks-generic
        v-for="(params, index) in block.params"
        class="step-text-block"
        :key="index"
        :params="params"/>
    </div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlocksGeneric from '@/components/generic/textBlocks/Generic'

/* Vue */
import { computed, onMounted } from 'vue'

/* Assets & Helpers */
import { ACCOUNTS_NIB_IBAN } from '@/assets/constants/masks'
import { amountFormat } from '@/assets/scripts/amounts'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getAccountsBalances } = mapGetters(moduleMapper.PAYMENTS_BAI_PAGA)

/* Emmitters */
const emit = defineEmits(['scrollTo'])

/* props received
@formData { Object } - object with info for our current form
*/
const props = defineProps({
    formData: Object
})

const paymentData = computed(() => {
    return [
        {
            divider: { icon: 'cart', title: t('payments.BAIPaga.dividers.merchantData'), applyBorder: false },
            params: [
                {
                    label: t('payments.BAIPaga.genericLabels.merchant'),
                    content: props.formData.merchantName
                }
            ]
        },
        {
            divider: { icon: 'account-balance', title: t('payments.BAIPaga.dividers.originAccount'), applyBorder: true },
            params: [
                {
                    label: t('payments.BAIPaga.genericLabels.originAccount'),
                    content: getAccountsBalances.value.find(account => account.id === props.formData.originAccount).accountNumber,
                    mask: ACCOUNTS_NIB_IBAN
                }

            ]
        },
        {
            divider: { icon: 'bills', title: t('payments.BAIPaga.dividers.amount') },
            params: [
                {
                    label: t('payments.BAIPaga.genericLabels.amount'),
                    content: amountFormat(props.formData.amount, props.formData.currency)
                }
            ]
        }
    ]
})

onMounted(() => {
    emit('scrollTo', 0)
})
</script>

<style lang="scss" scoped>
.step-section {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

}
</style>
